import { render, staticRenderFns } from "./BrunetteWaiting3.vue?vue&type=template&id=a26b9994&"
import script from "./BrunetteWaiting3.vue?vue&type=script&lang=ts&"
export * from "./BrunetteWaiting3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports